export default function SorryModal({ onClose }) {
  return (
    <div className="elig-modal-overlay">
      <div className="elig-modal elig-sorry-modal">
        <div className="elig-sorry-icon">
          <svg width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="#D32028" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h2>Application Not Eligible</h2>
        <p className="elig-modal-hint">
          We're sorry, the applicant does not meet the eligibility criteria at this time. Please try again with a different applicant.
        </p>
        <button className="elig-submit-btn elig-sorry-close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
}
